module.exports = __webpack_public_path__ + "img/line_ex.17f3988b.png";